<template>
  <div
    v-if="$store.getters.isLoggedIn"
    id="customers-table-page"
    class="page">
    <!-- Drawer -->
    <v-navigation-drawer
      v-model="isDrawerOpen"
      :width="drawerWidth"
      mobile-break-point="1024"
      floating
      app>
      <div class="page-logo-container mx-auto my-5">
        <PosmLogo />
      </div>

      <div class="page-navigation-container d-flex flex-column flex-grow-1">
        <CustomersSearchForm />
      </div>

      <!-- User Account Menu -->
      <UserMenu class="mt-auto" />
      <!-- User Account Menu -->
    </v-navigation-drawer>
    <!-- / Drawer -->

    <!-- Customers Page Content -->
    <v-content>
      <v-toolbar class="flex-column pa-2" style="height: auto; min-height: 80px;">
        <div class="d-flex flex-wrap align-center w-100 mt-5">
          <v-app-bar-nav-icon
            class="page-drawer-toggle mr-0"
            @click="isDrawerOpen = !isDrawerOpen">
          </v-app-bar-nav-icon>

          <v-toolbar-title
            class="pl-0">
            <MainNavigationMenu />
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Page Filter -->
          <div class="d-flex"
              :class="isMobile ? 'w-100' : ''">

            <div
              class="page-filter d-sm-block mr-5"
              :class="isMobile ? 'flex-grow-1' : ''">
              <v-text-field
                prepend-inner-icon="mdi-magnify"
                clearable
                outlined
                filled
                hide-details
                v-model="customersFilter"
                placeholder="Filter customers">
              </v-text-field>
            </div>
            <!-- / Page Filter -->

            <!-- Add New -->
            <v-btn
              class="toolbar-btn"
              color="primary"
              @click="openNewCustomer">
              <v-icon size="13">mdi-plus</v-icon>
              <span class="d-none d-sm-inline">Add New</span>
            </v-btn>
            <!-- / Add New -->
          </div>
        </div>
      </v-toolbar>

      <v-divider class="mx-5"></v-divider>

      <!-- Customers Table -->
      <CustomersTable
        class="page-content my-5 mx-5"
        :customers="customers"
      />
      <!-- / Customers Table -->
    </v-content>
    <!-- / Customers Page Content -->
  </div>
</template>

<script>
import _ from 'lodash';
import UserMenu from '../components/UserMenu.vue';
import CustomersTable from '../components/CustomersTable.vue';
import CustomersSearchForm from '../components/CustomersSearchForm.vue';
import MainNavigationMenu from '../components/MainNavigationMenu.vue';
import PosmLogo from '../components/PosmLogo.vue';

export default {
  name: 'CustomersTablePage',
  components: {
    UserMenu,
    CustomersTable,
    CustomersSearchForm,
    MainNavigationMenu,
    PosmLogo,
  },
  data() {
    return {
      customersFilter: '',
    };
  },
  computed: {
    customers() {
      const search = (this.customersFilter || '').toLowerCase();

      return _.filter(
        this.$store.state.customers,
        (customer) => !search
          || customer.CustomerName.toLowerCase().includes(search)
          || customer.CustomerPhone1.toLowerCase().includes(search),
      );
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    openNewCustomer() {
      this.$store.commit('setActiveCustomer');
      this.$router.push({ name: 'CustomerFormNewPage' });
    },
  },
};
</script>

<style lang="scss"></style>
